import axios from 'axios';

const allowReceivingAndSendingCookiesByACorsRequest = (): void => {
    axios.defaults.withCredentials = true;
};

allowReceivingAndSendingCookiesByACorsRequest();

export default axios;